import { Button, SegmentedButton } from "@/components/DesignSystem";
import Triangle from '@mui/icons-material/ChangeHistory';
import Check from "@mui/icons-material/Check";
import { useState } from "react";
import { DemoBlock } from "../../components/DemoBlock";

export const SegmentedButtonDemo = () => {

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const buttons = ["One", "Two", "Three", "Four", "Five"];
  const buttons2 = ["Any", "Pickup", "Delivery"];

  return (
    <>
      <DemoBlock label="No icons">
        <SegmentedButton color="primary" selectedIndex={selectedIndex}>
          {
            buttons.map((button, index) => (
              <Button
                aria-selected={selectedIndex === index}
                key={button}
                onClick={() => setSelectedIndex(index)}
                testID={`no-icons-${index}`}
              >
                {button}
              </Button>
            ))
          }
        </SegmentedButton>
      </DemoBlock>
      <DemoBlock label="Icons">
        <SegmentedButton color="primary" selectedIndex={selectedIndex}>
          {
            buttons.map((button, index) => (
              <Button
                aria-selected={selectedIndex === index}
                key={button}
                onClick={() => setSelectedIndex(index)}
                startIcon={
                  selectedIndex === index && <Check sx={{ width: "17px", height: "17px" }} />
                }
                testID={`no-icons-${index}`}
              >
                <Triangle sx={{ width: "13px", height: "13px" }} />
              </Button>
            ))
          }
        </SegmentedButton>
      </DemoBlock>
      <DemoBlock label="Disabled">
        <SegmentedButton color="primary" selectedIndex={selectedIndex}>
          {
            buttons.map((button, index) => (
              <Button
                aria-selected={selectedIndex === index}
                disabled
                key={button}
                onClick={() => setSelectedIndex(index)}
                startIcon={
                  selectedIndex === index && <Check sx={{ width: "17px", height: "17px" }} />
                }
                testID={`disabled-${index}`}
              >
                {button}
              </Button>
            ))
          }
        </SegmentedButton>
      </DemoBlock>
      <DemoBlock label="Real world example">
        <SegmentedButton color="primary" selectedIndex={selectedIndex}>
          {
            buttons2.map((button, index) => (
              <Button
                aria-selected={selectedIndex === index}
                key={button}
                onClick={() => setSelectedIndex(index)}
                startIcon={
                  selectedIndex === index && <Check sx={{ width: "17px", height: "17px" }} />
                }
                testID={`rwe-${index}`}
              >
                {button}
              </Button>
            ))
          }
        </SegmentedButton>
      </DemoBlock>
    </>
  );
};
